// extracted by mini-css-extract-plugin
export default {"button":"Button_button__nWIY3","full":"Button_full__rodFD"};